import * as actions from './actions'
import { saveEntities } from '../factories'
import { sequences as route } from '../route'
import { showFeedback } from '../feedback/factories'
import { set, when } from 'cerebral/factories'
import { props } from 'cerebral'

export const find = [
  //
  actions.find,
  saveEntities(),
]

export const findForList = [
  //
  set(props`useRouteParams`, true),
  actions.find,
  actions.setList,
  saveEntities(),
]

export const get = [
  //
  actions.get,
  saveEntities(),
]

export const save = [
  //
  actions.save,
  actions.clearList,
  saveEntities(),
  showFeedback({ title: 'Area saved', type: 'success' }),
  when(props`noRedirect`),
  {
    false: route.toMapAreas,
    true: [],
  },
]

export const remove = [
  //
  actions.remove,
  showFeedback({ title: 'Area deleted', type: 'success' }),
  findForList,
]
